import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/images/imoneyIcon1.png'
import _imports_1 from '../../assets/images/echec.svg'
import _imports_2 from '../../assets/images/success.svg'
import _imports_3 from '../../assets/images/pending.svg'


const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing invisible",
  id: "back"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_4 = {
  class: "d-sm-flex align-items-center",
  style: {"width":"30%"}
}
const _hoisted_5 = {
  type: "button",
  class: "default-btn d-block text-center w-80 border-0 box-shadow fw-medium text-white rounded-1 pt-12 pb-12 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
  "data-bs-toggle": "modal",
  "data-bs-target": "#generateLink"
}
const _hoisted_6 = { class: "d-sm-flex align-items-center" }
const _hoisted_7 = { class: "select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0" }
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { id: "transactionsTable" }
const _hoisted_11 = { class: "p-right" }
const _hoisted_12 = {
  class: "d-lg-block p-2 text-end redcolor",
  style: {"font-weight":"1000"}
}
const _hoisted_13 = {
  id: "",
  class: "d-block p-2 text-end redcolor",
  style: {"margin-top":"-8%"}
}
const _hoisted_14 = {
  id: "",
  class: "d-block p-2 text-end redcolor",
  style: {"margin-top":"-8%"}
}
const _hoisted_15 = {
  class: "d-block p-2 text-end redcolor",
  style: {"margin-top":"-8%"}
}
const _hoisted_16 = {
  class: "d-block p-2 text-end redcolor",
  style: {"margin-top":"-8%"}
}
const _hoisted_17 = {
  id: "",
  class: "d-block p-2 text-end redcolor",
  style: {"margin-top":"-8%"}
}
const _hoisted_18 = {
  class: "d-block p-2 text-end redcolor",
  style: {"margin-top":"-8%"}
}
const _hoisted_19 = {
  class: "d-block p-2 text-end redcolor",
  style: {"margin-top":"-8%"}
}
const _hoisted_20 = { style: {"margin-top":"7%"} }
const _hoisted_21 = {
  class: "shadow-none lh-1 fw-medium",
  id: "title",
  style: {}
}
const _hoisted_22 = { id: "title1" }
const _hoisted_23 = {
  class: "text-end",
  id: "title2"
}
const _hoisted_24 = { class: "date" }
const _hoisted_25 = { class: "date" }
const _hoisted_26 = {
  style: {"padding-left":"1%","padding-right":"1%"},
  class: ""
}
const _hoisted_27 = {
  id: "tableLayout",
  class: "table",
  style: {"margin-right":"1%"}
}
const _hoisted_28 = {
  id: "t-thead-pdf",
  style: {}
}
const _hoisted_29 = {
  scope: "col",
  style: {},
  class: "tableHeader"
}
const _hoisted_30 = { class: "tableHeader" }
const _hoisted_31 = { class: "tableHeader" }
const _hoisted_32 = {
  scope: "col",
  class: "tableHeader"
}
const _hoisted_33 = {
  scope: "col",
  class: "tableHeader"
}
const _hoisted_34 = {
  scope: "col",
  class: "tableHeader1",
  style: {"border-top-left-radius":"1px","border-bottom-left-radius":"1px"}
}
const _hoisted_35 = { class: "fw-medium" }
const _hoisted_36 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_37 = { class: "fw-medium" }
const _hoisted_38 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_39 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_40 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { key: 3 }
const _hoisted_45 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_46 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_47 = { class: "modal-content" }
const _hoisted_48 = { class: "modal-header" }
const _hoisted_49 = {
  key: 0,
  class: "modal-title fs-5"
}
const _hoisted_50 = { class: "modal-body" }
const _hoisted_51 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_52 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_53 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_54 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = {
  key: 0,
  class: "col-md-10"
}
const _hoisted_57 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_58 = { value: "" }
const _hoisted_59 = ["value"]
const _hoisted_60 = { class: "col-md-2" }
const _hoisted_61 = {
  class: "form-check",
  style: {"margin-top":"40%"}
}
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-md-6" }
const _hoisted_64 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_65 = { class: "col-md-6" }
const _hoisted_66 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_67 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_68 = ["disabled"]
const _hoisted_69 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_70 = { style: {"color":"#FFF"} }

import {ref, onMounted,onBeforeMount,inject  } from "vue";
import axios from 'axios';
import flatpickr from "flatpickr";
import html2pdf from "html2pdf.js";
import router from '../../router/index'
import { useI18n } from "vue-i18n";
import {current_permissions} from '../../utils/permission';
import { showToast,validate_phone_number,checkSessionValidate } from "@/utils/function";
// import {SERVER} from "../../../utils/const"
// import {export_json_to_excel} "../../../utils/Export2Excel";
declare interface Transaction {
    id: number,
    checkoutId: string,
    operator: string,
    contact: string,
    amount: string,    
    transactionDate: string,
    paymentStatus: string
  }

  declare interface Organization {
  id : string,
  code: string,
  name: string,
  description: string,    
  email: string,
  created_at: string
  }

  declare interface Operator {
  id : string,
  code: string,
  mnoName: string,
  status: string,    
  countryCode: string  
  }

const leadPlaceholder = "Select date";


export default /*@__PURE__*/_defineComponent({
  __name: 'ExportContent',
  setup(__props) {

const backApi=inject('back');

let data = [];
let transaction1s = ref([]);
let beginDate = ref('');
let endDate = ref('');
let today = ref('');
const selectedOrganization = ref('');
const selectedOperator = ref('');
const selectedStatus = ref('');
const loader = ref(false);
const page = ref(1);
const total = ref(0);
let link = ref('');
let amount = ref(0);
//const pageServ = ref('');
const pagesLeft = ref(0);
const { locale, t } = useI18n();
const currentPage = ref(0);
const numPages = ref(0);
const gettran = ref(false);
const search = ref(false);
const search1 = ref(false);
const operator = ref('');
const paymentStatus = ref(''); 
const screenSelected = ref(''); 
const btnLoad = ref(true);
const errors = ref('');
const errorId = ref('');
let result = ref(0);    
const transactions =ref(new Array<Transaction>());
const organizations =ref(new Array<Organization>());
const operators =ref(new Array<Operator>());
let operatorsTemp =new Array<Operator>();
const transaction =ref({} as Transaction);
const organization_name =  localStorage.getItem('organization_name');
const email =  localStorage.getItem('email');

let export_organisation_name = ref('');
let export_email = ref('');
let export_start = ref('');
let export_end = ref('');
  function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();  
        day = day<10?'0'+day:day;      
        return day+'/'+month+'/'+year;
        
    }
}

function formatDateEn(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;  
        day = day<10?'0'+day:day;      
        return year+'-'+month+'-'+day;
        
    }
}

function formatDateEnBis(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;  
        day = day<10?'0'+day:day;      
        return year+'-'+month+'-'+day;
        
    }
}


function closeModal() {
      router.go(-1);
}
function handleOrganizationChange(event) {
      selectedOrganization.value = event.target.value;
    }

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleStatusChange(event) {
  selectedStatus.value = event.target.value;
}

function handleCountryChange(event) {
  // // selectedStatus.value = event.target.value;
  // operators
  var j = 0;
  var operatorArr = new Array<Operator>();
  while(j<operatorsTemp.length){    
      if(operatorsTemp[j].countryCode == event.target.value){         
          operatorArr.push(operatorsTemp[j]);
      }      
      j++;
  }
   operators.value = operatorArr;
}

function reset(){
  amount.value = 0;
  link.value = '';
  result.value=0;
}

function copyToCliboard() {
  // Get the text field
  var copyText = document.getElementById("link");
  // Select the text field
  copyText.select();
  copyText.setSelectionRange(0, 99999); // For mobile devices
   // Copy the text inside the text field
  navigator.clipboard.writeText(copyText.value);
  showToast("Copié","green");
}

const generateLink = ()=>{

try {  
  
  axios.post(`${backApi}/secure/transactions/token`,{          
          amount:amount.value,          
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {  
        if(response.status === 201){  
          // alert(response.data.ticketUrl); 
          link.value =  response.data.ticketUrl
          result.value=1;
        }      
        
    }).catch((error) => {
      // alert(error.response.data.errorId);
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              } 
              
          }
  });
} catch (error) {
        // console.log(error);        
         errors.value="une erreur inattendue est apparue"
         
              
}

}
    


onMounted(() => {
  checkSessionValidate(1)
  // getTransactions();
  getOrganizations();
  // getOperators();
  
  setTimeout(function () {
    //loader.value=true; 
        flatpickr("#lead-calendar", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
        enableTime: true,
      });
        },1000);

        loader.value=true;
});

setTimeout(function () {
  const excel = document.getElementById("excel");
  excel?.click()
},1000);

const token =  localStorage.getItem('login_token');
const loadTransaction = (code)=>{
  
  axios.get(`${backApi}/secure/transactions/${code}`,{//SERVER+ //https://test.zivwallet.com/api/countries//dateD=${today}&
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        transaction.value = response.data;  //.data.users   
        // data  = response.data.transactions;  
        operator.value=  response.data.operator.mnoName;
        amount.value= response.data.amount.toLocaleString();
       
         if(response.data.paymentStatus==='SUCCEEDED'){
          paymentStatus.value = "SUCCESS"
         }else if(response.data.paymentStatus==='PROCESSING'){
          paymentStatus.value = "EN COURS"
         }else{
          paymentStatus.value = "ECHEC"
         }   
         
        loader.value=true;
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              }   
              
          }
  });
}
const getTransactions = (arg=1) =>{
    loader.value=false;
    gettran.value = true;
    search.value = false;
    search1.value = false;
    
    const todayB =  formatDateEn(new Date()); //'2024/01/01'
    const todayE =  formatDateEn(new Date(),1);   
    //conf.proxy
    axios.get(`${backApi}/secure/transactions?page=${arg}&dateD=${todayB}&dateF=${todayE}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{//SERVER+ //https://test.zivwallet.com/api/countries//dateD=${today}&
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        transactions.value = response.data.transactions;  //.data.users   
        // data  = response.data.transactions;  
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.page);
        pagesLeft.value=parseInt(response.data.pagination.pagesLeft);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);
        
        // for (let pas = 0; pas < data.length; pas++) {
        //   data[pas].operator_name = data[pas].operator.mnoName;
        // }    
         //console.log(pagination.value);
        loader.value=true;
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              }   
              
          }
  });

}
const getOrganizations = () =>{

    axios.get(backApi+'/secure/organizations/',{  
      headers: {
           
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {
        // users.value = response.data;
        organizations.value = response.data;  //.data.users          
        console.log(response.data);
        
        
    }).catch((error) => {
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                //window.location.href = '/';
                //router.push('/');
              }   
              
          }
   });
  //  loader.value=true;
}
const getOperators = () =>{

axios.get(backApi+'/public/operators/',{  //secure
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
    // users.value = response.data;
    operatorsTemp = response.data;  //.data.users          
    console.log(response.data);
    
    
}).catch((error) => {
      if( error.response){
          console.log(error.response.data); // => the response payload 
          if(error.response.status === 401){
            router.push('/')
            
          }   
          
      }
});
//  loader.value=true;
}

const exportExcelReport = (labels,fields,filename) =>{
  
  import("../../utils/Export2Excel").then((excel)=>{
 
    const dataForExcel= formatJSon(fields,data);
    // console.log(dataForExcel);
    excel.export_json_to_excel({     
      header:labels,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:filename,      
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}

const exportExcelReportOld = () =>{
  
  import("../../utils/Export2Excel").then((excel)=>{
    // const data = transactions.value;
    const Header =["CODE TRANSACTION","DATE OPERATION","OPERATEUR","MONTANT","TYPE OPERATION","BALANCE","STATUT"];
    const Fields = ["checkoutId","transactionDate","status","amount","operationType","","paymentStatus"];//"operator_name",
    // console.log(data);
    const dataForExcel= formatJSon(Fields,data);
    // console.log(dataForExcel);
    excel.export_json_to_excel({     
      header:Header,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:"report",      
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}

const exportExcel = () =>{
  
  import("../../utils/Export2Excel").then((excel)=>{
    // const data = transactions.value;
    const Header =["CODE TRANSACTION","OPERATEUR","TELEPHONE","MONTANT","DATE","STATUT"];
    const Fields = ["checkoutId","operator_name","contact","amount","transactionDate","paymentStatus"];//mnoName
    // console.log(data);
    const dataForExcel= formatJSon(Fields,data);
    // console.log(dataForExcel);
    excel.export_json_to_excel({     
      header:Header,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:"transactions",      
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}


function formatJSon(FilterData,JsonData){
  return JsonData.map((v)=>FilterData.map(j=>{
      return v[j];
    }));
}


//[top, left, bottom, right]
const searchTransaction = (arg=1)=>{
  loader.value=false;
  gettran.value = false;
  search.value = true;
  search1.value = false;
  
  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date()); 
  }
   
  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1); 
  }
    const todayE =  formatDateEn(new Date(endDate.value),1);   
  axios.get(`${backApi}/secure/transactions?page=${arg}&dateD=${beginDate.value}&dateF=${todayE}&organization=${selectedOrganization.value}&operator=${selectedOperator.value}&paymentStatus=${selectedStatus.value}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{//SERVER+ //https://test.zivwallet.com/api/countries
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        transactions.value = response.data.transactions;  //.data.users   
        // data  = response.data.transactions;  
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.page);
        pagesLeft.value=parseInt(response.data.pagination.pagesLeft);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);
        // for (let pas = 0; pas < data.length; pas++) {
        //   data[pas].operator_name = data[pas].operator.mnoName;
        // }    
        //  console.log(data);
        loader.value=true; 
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              }   
              
          }
  });
}
const searchTransaction1 = (event,arg=1)=>{ 
  // alert(typeof event ) 
  // alert(event.target.value)
  // alert(arg)  
   if(typeof event.target.value!=='undefined'){
    today.value = event.target.value 
   }  
  
    // alert(today.value)  
    loader.value=false;
    gettran.value = false;
    search.value = false;
    search1.value = true;

    const todayE =  formatDateEn(new Date(today.value),1);   
  axios.get(`${backApi}/secure/transactions?page=${arg}&dateD=${today.value}&dateF=${todayE}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{//SERVER+ //https://test.zivwallet.com/api/countries
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        transactions.value = response.data.transactions;  //.data.users   
        // data  = response.data.transactions;  
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.page);
        pagesLeft.value=parseInt(response.data.pagination.pagesLeft);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);
        // for (let pas = 0; pas < data.length; pas++) {
        //   data[pas].operator_name = data[pas].operator.mnoName;
        // }    
        //  console.log(data);
        loader.value=true; 
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              }   
              
          }
  });
}

const searchTransactionForExport = ()=>{  
   btnLoad.value=false;
  
  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date()); 
  }
   
  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1); 
  }

  let check = document.getElementById("invalidCheck").checked;
  let option= '';
  // alert(check);
  // let custom = 0;
  const todayE =  formatDateEn(new Date(endDate.value),1);
  let endpointEnd = (selectedOrganization.value==='')?'global':'organization' 
  if(endpointEnd=='global'){
    endpointEnd = (check)?endpointEnd+'/custom':endpointEnd
  }
  
  let body={
    start: beginDate.value,
    end: todayE,
    organization: (selectedOrganization.value==='')?null:selectedOrganization.value
  }

     
  axios.post(`${backApi}/secure/report/${endpointEnd}`,
    body,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        // transactions.value = response.data.transactions;  //.data.users 
        data = [];
        if(response.status === 200){  
         
        if(option=='excel'){
        let Header =[];
        let Fields =[];
        if(endpointEnd=='organization'){
          data  = response.data.transactions; 
          for (let pas = 0; pas < data.length; pas++) {
          data[pas].operator_name = data[pas].operator.mnoName;
          let operationType = data[pas].operationType;
          data[pas].operationType = (operationType=="1")?"Payin":"Payout";
          data[pas].checkoutId = (operationType=="1")?data[pas].checkoutId:data[pas].payoutId;          
          // data[pas].balance = parseFloat(data[pas].collectBalance-(data[pas].payoutBalance-data[pas].topupBalance));//repayment_balance 

          }  
        
          Header =["CODE TRANSACTION","DATE OPERATION","OPERATEUR","MONTANT","TYPE OPERATION","SOLDE DE COLLECTE","SOLDE DE TRANSFERT","STATUT"];
          Fields = ["checkoutId","transactionDate","operator_name","amount","operationType","collectBalance", "payoutBalance","paymentStatus"];
        }else{
            if(!check){
              let temp  = response.data;  
              let tempJson = {
                start:temp.start,
                collectBalance:temp.startData.collectBalance,
                availableBalance:temp.startData.availableBalance,
                payoutBalance:temp.startData.payoutBalance,
                end:temp.end,
                collectBalanceEnd:temp.endData.collectBalance,
                availableBalanceEnd:temp.endData.availableBalance,
                payoutBalanceEnd:temp.endData.payoutBalance,
              } 
              data.push(tempJson);
              Header =["DEBUT PERIODE","SOLDE DE COLLECTE","SOLDE DISPONIBLE","SOLDE DE TRANSFERT","FIN PERIODE","SOLDE DE COLLECTE","SOLDE DISPONIBLE","SOLDE DE TRANSFERT"];
              Fields = ["start","collectBalance","availableBalance","payoutBalance","end","collectBalanceEnd","availableBalanceEnd","payoutBalanceEnd"];
            }else{
              let temp  = response.data;  
              // let i = 0;
              for (let i = 0; i < temp.reports.length; i++) {
                let tempJson = {
                  organization:temp.reports[i].organization.name,
                  start:temp.start,
                  collectBalance:temp.reports[i].startData.collectBalance,
                  availableBalance:temp.reports[i].startData.availableBalance,
                  payoutBalance:temp.reports[i].startData.payoutBalance,
                  end:temp.end,
                  collectBalanceEnd:temp.reports[i].endData.collectBalance,
                  availableBalanceEnd:temp.reports[i].endData.availableBalance,
                  payoutBalanceEnd:temp.reports[i].endData.payoutBalance,
                } 
                // console.log(tempJson);
                data.push(tempJson);
              }
              Header =["ORGANISATION","DEBUT PERIODE","SOLDE DE COLLECTE","SOLDE DISPONIBLE","SOLDE DE TRANSFERT","FIN PERIODE","SOLDE DE COLLECTE","SOLDE DISPONIBLE","SOLDE DE TRANSFERT"];
              Fields = ["organization","start","collectBalance","availableBalance","payoutBalance","end","collectBalanceEnd","availableBalanceEnd","payoutBalanceEnd"];
            }
        }
        exportExcelReport(Header,Fields,"report");  
        }else{
             
              export_organisation_name.value=response.data.organization.name
              export_email.value=response.data.organization.email
              // export_balance_transfert.value=response.data.end.payout_balance
              // export_balance_collecte.value=response.data.end.collect_balance

              export_start.value=response.data.start
              export_end.value=response.data.end
              transaction1s.value=response.data.operations;
              // alert(response.data.organization.name)
              exportToPDF()  
        }


        btnLoad.value=true; 
      }   
    }).catch((error) => {
      btnLoad.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              } else{                
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;               
         
              }  
              
          }
  });
}

const reportForExport = ()=>{  
   btnLoad.value=false;
  
  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date()); 
  }
   
  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1); 
  }
  // alert(selectedOrganization.value);
    const todayE =  formatDateEn(new Date(endDate.value),1);   
  axios.post(`${backApi}/secure/organizations/report`,
       {          
         start:beginDate.value,
         end:todayE,
          organization:selectedOrganization.value          
        },
        {
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {        
        if(response.status === 200){  
        data  = response.data.transactions;  
        // const dataTemp  = response.data; 
        console.log(data)
        
        for (let pas = 0; pas < data.length; pas++) {
          // data[pas].operator_name = data[pas].operator.mnoName;
          data[pas].operationType = (data[pas].operationType=="1")?"Payin":"Payout";
          data[pas].balance = parseFloat(data[pas].collectBalance-(data[pas].payoutBalance-data[pas].topupBalance));        
        }  
        
        const Header =["CODE TRANSACTION","DATE OPERATION","OPERATEUR","MONTANT","TYPE OPERATION","BALANCE","STATUT"];
        const Fields = ["checkoutId","transactionDate","status","amount","operationType","","paymentStatus"];

        exportExcelReport(Header,Fields,"report"); 
        //  console.log(data);
        btnLoad.value=true; 
      }   
    }).catch((error) => {
      btnLoad.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              } else{                
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;               
         
              }  
              
          }
  });
}

const showScreen = (screen)=>{ 
  screenSelected.value=screen
}


const exportToPDF = () =>{   
  
  setTimeout(() => {  

        document.getElementById("transactionsTable").style.display='block';
        const opt ={margin: [0, 0, 0, 0],filename: "transactions.pdf",jsPDF:{ unit: 'mm', format: 'a4', orientation: 'portrait',putOnlyUsedFonts:true,floatPrecision: "smart"  },image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 2 },}
        // const opt ={margin: [0, 0, 0, 0],filename: "transactions.pdf",jsPDF:{ unit: 'mm', format: 'a4', orientation: 'portrait',putOnlyUsedFonts:true,floatPrecision: "smart"  }}
        //landscape//portrait/format: 'letter'/unit: 'in',/unit: 'mm',/unit: 'cm',
      
      html2pdf().set(opt).from(document.getElementById("transactionsTable")).toPdf().get('pdf').then(function (pdf) {
      
      window.open(pdf.output('bloburl'), '_blank');
      document.getElementById("transactionsTable").style.display='none';
      });

    }, 3000);
    
 
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "default-outline-btn position-relative transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
                type: "button",
                style: {"background-color":"#EB9355"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showScreen('excel'))),
                "data-bs-toggle": "modal",
                "data-bs-target": "#filterLeadModal",
                id: "excel"
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('export.excel')) + " ", 1),
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1))
              ]),
              _cache[8] || (_cache[8] = _createTextVNode("      ", -1)),
              _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.$t('export.paymentLink')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(today) ? (today).value = $event : today = $event)),
                    type: "date",
                    class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                    id: "lead-calendar",
                    placeholder: leadPlaceholder,
                    onChange: searchTransaction1
                  }, null, 544), [
                    [_vModelText, _unref(today)]
                  ])
                ])
              ]),
              _createElementVNode("button", {
                class: "dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block mt-10 mt-sm-0",
                type: "button",
                "data-bs-toggle": "modal",
                "data-bs-target": "#filterLeadModal",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showScreen('search')))
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "flaticon-dots" }, null, -1)
              ]))])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "d-lg-inline-block p-2 text-start" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "logo-icon",
                      style: {"max-width":"5%"}
                    }),
                    _createElementVNode("span", { id: "logo_text" }, "IZYPAY")
                  ], -1)),
                  _cache[11] || (_cache[11] = _createElementVNode("span", {
                    id: "headerLeftText",
                    class: "d-lg-inline-block p-2 text-start",
                    style: {"margin-top":"-2%"}
                  }, "support@imoney.africa", -1)),
                  _createElementVNode("p", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(export_organisation_name)), 1),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(export_email)), 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(formatDateFr(new Date((_unref(export_start)).date))), 1),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('export.transferBalance')) + " : " + _toDisplayString(_unref(export_start).payout_balance) + " XOF", 1),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('export.collectBalance')) + " : " + _toDisplayString(_unref(export_start).collect_balance) + " XOF", 1),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(formatDateFr(new Date((_unref(export_end)).date))), 1),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('export.transferBalance')) + " : " + _toDisplayString(_unref(export_end).payout_balance) + " XOF", 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('export.collectBalance')) + " : " + _toDisplayString(_unref(export_end).collect_balance) + " XOF", 1)
                  ])
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("h2", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('export.operationsStatement')), 1),
                    _createElementVNode("span", _hoisted_23, [
                      _createTextVNode(_toDisplayString(_ctx.$t('export.period')) + " ", 1),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(formatDateFr(new Date((_unref(beginDate))))), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('export.to')) + " ", 1),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(formatDateFr(new Date((_unref(endDate))))), 1)
                    ])
                  ])
                ]),
                _cache[17] || (_cache[17] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("table", _hoisted_27, [
                    _createElementVNode("thead", _hoisted_28, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.$t('export.transactionCode')), 1),
                        _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.$t('export.operation')), 1),
                        _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.$t('export.fees')), 1),
                        _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.$t('export.amount')), 1),
                        _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.$t('export.date')), 1),
                        _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.$t('export.status')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transaction1s), (transaction1) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: transaction1.transaction_number
                        }, [
                          _createElementVNode("td", _hoisted_35, _toDisplayString(transaction1.transaction_number), 1),
                          _createElementVNode("td", _hoisted_36, _toDisplayString(transaction1.operation), 1),
                          _createElementVNode("td", _hoisted_37, [
                            _createElementVNode("span", null, _toDisplayString(transaction1.fees.toLocaleString()), 1)
                          ]),
                          _createElementVNode("td", _hoisted_38, [
                            _createElementVNode("span", null, _toDisplayString(transaction1.amount.toLocaleString()), 1)
                          ]),
                          _createElementVNode("td", _hoisted_39, _toDisplayString(formatDateFr(new Date(transaction1.date))), 1),
                          _createElementVNode("td", _hoisted_40, [
                            (transaction1.status==='FAILED')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('export.failed')) + " ", 1),
                                  _cache[12] || (_cache[12] = _createElementVNode("img", {
                                    src: _imports_1,
                                    alt: "logo-icon",
                                    style: {"max-width":"25%"}
                                  }, null, -1))
                                ]))
                              : _createCommentVNode("", true),
                            (transaction1.status==='SUCCEEDED')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('export.success')) + " ", 1),
                                  _cache[13] || (_cache[13] = _createElementVNode("img", {
                                    src: _imports_2,
                                    alt: "logo-icon",
                                    style: {"max-width":"25%"}
                                  }, null, -1))
                                ]))
                              : _createCommentVNode("", true),
                            (transaction1.status==='PROCESSING')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('export.processing')) + " ", 1),
                                  _cache[14] || (_cache[14] = _createElementVNode("img", {
                                    src: _imports_3,
                                    alt: "logo-icon",
                                    style: {"max-width":"25%"}
                                  }, null, -1))
                                ]))
                              : _createCommentVNode("", true),
                            (transaction1.status==='PENDING')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('export.pending')) + " ", 1),
                                  _cache[15] || (_cache[15] = _createElementVNode("img", {
                                    src: _imports_3,
                                    alt: "logo-icon",
                                    style: {"max-width":"25%"}
                                  }, null, -1))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            (screenSelected.value=='excel')
              ? (_openBlock(), _createElementBlock("h1", _hoisted_49, _toDisplayString(_ctx.$t('export.exportFinancialData')), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: closeModal
            })
          ]),
          _createElementVNode("div", _hoisted_50, [
            (errors.value!=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("h6", _hoisted_52, "code: " + _toDisplayString(errorId.value), 1),
                  _createElementVNode("h6", _hoisted_53, _toDisplayString(errors.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                (_unref(current_permissions)('SUPERADMIN'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t('export.clients')), 1),
                      _createElementVNode("select", {
                        name: "organization",
                        id: "organization",
                        class: "form-select fs-md-15 text-black shadow-none",
                        onChange: handleOrganizationChange,
                        required: ""
                      }, [
                        _createElementVNode("option", _hoisted_58, _toDisplayString(_ctx.$t('export.select')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: organization.code,
                            key: organization.id
                          }, _toDisplayString(organization.name), 9, _hoisted_59))
                        }), 128))
                      ], 32)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _cache[18] || (_cache[18] = _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: "1",
                      id: "invalidCheck"
                    }, null, -1)),
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('export.detail')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t('export.startDate')), 1),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(beginDate) ? (beginDate).value = $event : beginDate = $event)),
                      type: "text",
                      class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                      id: "lead-calendar",
                      placeholder: leadPlaceholder
                    }, null, 512), [
                      [_vModelText, _unref(beginDate)]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.$t('export.endDate')), 1),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(endDate) ? (endDate).value = $event : endDate = $event)),
                      type: "text",
                      class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                      id: "lead-calendar",
                      placeholder: leadPlaceholder
                    }, null, 512), [
                      [_vModelText, _unref(endDate)]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          (_unref(current_permissions)('global_report'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                (screenSelected.value=='excel')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      disabled: !btnLoad.value,
                      type: "button",
                      class: "btn",
                      style: {"background-color":"#EB9355"},
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (searchTransactionForExport()))
                    }, [
                      (!btnLoad.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_69))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.$t('export.exportBtn')), 1)
                    ], 8, _hoisted_68))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _cache[19] || (_cache[19] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})